import React from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LoadErrorAlert({ onRetry }) {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          {t('onboarding:shared.retry')}
        </Button>
      }
    >
      {t('onboarding:shared.load_failed')}
    </Alert>
  );
}
